import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Password from "../Login/Password";
import {
  IcMenu, IcChevL, IcChevR, IcChevD, IcChevU,
  IcUserCircle, IcLock, IcSignOut,
} from "../../Icons";

// ── SVG base (para los iconos de nav personalizados) ──────────────────────────
const S = ({ size = 18, children, style }) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke="currentColor"
    strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true"
    style={{ flexShrink: 0, display: "inline-block", verticalAlign: "middle", ...style }}
  >
    {children}
  </svg>
);

// Clientes — persona principal + segunda persona detrás (más tenue)
// Cargos — documento con doblez + signo $
// Abonos — billetera con flecha de entrada
// Mensualidades — calendario con puntos en los días
// Estado de Cuenta — documento con línea de tendencia ascendente
// Gastos — cartera/billetera con moneda
// Fiscal — documento tipo recibo con sello/timbre en esquina
// Reportes — barras ascendentes con línea de tendencia
const IcReportes = () => (
  <S>
    <line x1="3" y1="21" x2="21" y2="21"/>
    <rect x="4"  y="13" width="4" height="8" rx="1"/>
    <rect x="10" y="8"  width="4" height="13" rx="1"/>
    <rect x="16" y="4"  width="4" height="17" rx="1"/>
    <polyline points="5 10 10 6 15 9 20 3" strokeDasharray="1.5 1.5" strokeOpacity={0.6}/>
  </S>
);

// Usuarios — persona con escudo/check (gestión de acceso)
const IcUsuarios = () => (
  <S>
    <circle cx="10" cy="7" r="4"/>
    <path d="M3 21v-1a7 7 0 0 1 7-7h1.5"/>
    <path d="M17 13l1 1 3-3" strokeWidth="1.8"/>
    <circle cx="19" cy="17" r="3.5"/>
  </S>
);

// Logs — portapapeles con lista de ítems (puntos + líneas)
const IcLogs = () => (
  <S>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
    <rect x="8" y="2" width="8" height="4" rx="1"/>
    <circle cx="9" cy="11" r="1"  fill="currentColor" strokeWidth="0"/>
    <line  x1="12" y1="11" x2="17" y2="11"/>
    <circle cx="9" cy="15.5" r="1" fill="currentColor" strokeWidth="0"/>
    <line  x1="12" y1="15.5" x2="17" y2="15.5"/>
    <circle cx="9" cy="20"   r="1" fill="currentColor" strokeWidth="0" strokeOpacity={0.4}/>
    <line  x1="12" y1="20"   x2="15" y2="20" strokeOpacity={0.4}/>
  </S>
);

// Lugares Fiestas — boleto/entrada con perforación

// ── Iconos propios de NinaFerre ────────────────────────────────────────────
// Modelos — etiqueta de prenda
const IcModelos = () => (
  <S>
    <path d="M20.6 7.5 16 5l-1.5 1.5a3.5 3.5 0 0 1-5 0L8 5 3.4 7.5l2 4 2-1v9h9.2v-9l2 1z"/>
  </S>
);
// Compras — carrito
// Tiendas — local con toldo
const IcTiendas = () => (
  <S>
    <path d="M3 9V7l2-4h14l2 4v2"/>
    <path d="M3 9a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 3 0"/>
    <path d="M4.5 11v9h15v-9"/>
    <rect x="9.5" y="14" width="5" height="6"/>
  </S>
);
// Inventarios — cajas apiladas
// Configuracion — engrane
// WhatsApp — globo de chat
// Empleados — grupo de personas
const IcEmpleados = () => (
  <S>
    <circle cx="9" cy="8" r="3.2"/>
    <path d="M2.5 20v-1a6.5 6.5 0 0 1 13 0v1"/>
    <path d="M17 11.2A3 3 0 1 0 17 5.3"/>
    <path d="M18 13.5a5.5 5.5 0 0 1 3.5 5.1V20"/>
  </S>
);

// ── Navegacion agrupada por seccion (NinaFerre) ────────────────────────────
const NAV_SECTIONS = [
  {
    section: "Operación",
    items: [
      { label: "Punto de Venta", icon: <IcTiendas />, href: "/PuntoVenta",    perm: "pos" },
      { label: "Modelos",        icon: <IcModelos />, href: "/MenuArticulos", perm: "menu_articulos" },
    ],
  },
  {
    section: "Análisis",
    items: [
      { label: "Reportes", icon: <IcReportes />, href: "/PosReportes", perm: "posReportes" },
    ],
  },
  {
    section: "Administración",
    items: [
      { label: "Empleados", icon: <IcEmpleados />, href: "/MenuNominas",  perm: "menu_empleados" },
      { label: "Usuarios",  icon: <IcUsuarios />,  href: "/MenuUsuarios", perm: "menu_usuarios" },
      { label: "Logs",      icon: <IcLogs />,      href: "/MenuLogs",     perm: "menu_logs" },
    ],
  },
];

const POS_PERMISOS = ["posVender", "posCorte", "posVentas", "posDevoluciones", "posInventario", "posEntradas", "posCancelarEntradas", "posVenderSinExistencia", "posEtiquetas", "posTraspasos", "posRecibir", "posCaja", "posReportes", "posPromociones", "posTiendas"];

const Header = () => {
  const { isAuth, user } = useContext(AuthContext);

  const [sidebarOpen,   setSidebarOpen]   = useState(false);
  const [modalPassword, setModalPassword] = useState(false);
  const [userMenuOpen,  setUserMenuOpen]  = useState(false);
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem("sidebar-collapsed") === "true"
  );

  const currentPath = window.location.pathname;

  // Usuario de tienda: solo ve el Punto de Venta (el back también le cierra todo lo demás)
  const esDeTienda = !!user && user.rolTiendas === "tienda";
  const soloEventos = false; // NinaFerre no tiene usuarios "solo eventos"

  // Un usuario de tienda que cae en otra pantalla regresa al Punto de Venta
  useEffect(() => {
    if (esDeTienda && !/^\/(PuntoVenta|Pos)/.test(window.location.pathname)) {
      window.location.replace("/PuntoVenta");
    }
  }, [esDeTienda]);

  // ── Body classes ──────────────────────────────────────────────────────────
  useEffect(() => {
    if (!isAuth || soloEventos) return;
    document.body.classList.add("has-sidebar");
    if (collapsed) document.body.classList.add("sidebar-collapsed");
    return () => {
      document.body.classList.remove("has-sidebar");
      document.body.classList.remove("sidebar-collapsed");
    };
  }, [isAuth, soloEventos]); // eslint-disable-line

  if (!isAuth) return null;
  if (soloEventos) return null; // sin header/sidebar para usuarios solo de Lugares Fiestas

  // ── Helpers ───────────────────────────────────────────────────────────────
  const hasPerm = (perm) => {
    // TIENDAS: lo ve quien este en area General o tenga el permiso.
    if (perm === "pos") return !!user.rolTiendas && POS_PERMISOS.some((k) => user[k]);
    return !!user[perm];
  };

  const toggleCollapse = () => {
    const next = !collapsed;
    setCollapsed(next);
    localStorage.setItem("sidebar-collapsed", next);
    if (next) {
      document.body.classList.add("sidebar-collapsed");
      setUserMenuOpen(false);
    } else {
      document.body.classList.remove("sidebar-collapsed");
    }
  };

  return (
    <>
      {/* ── Mobile top bar ──────────────────────────────────────────────── */}
      <div className="sidebar-topbar d-lg-none">
        <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
          <IcMenu />
        </button>
        <a href="/Inicio">
          <img src={process.env.PUBLIC_URL + "/logoInstitucion.png"} height="34" alt="logo" />
        </a>
      </div>

      {/* ── Mobile overlay ──────────────────────────────────────────────── */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ── Sidebar ─────────────────────────────────────────────────────── */}
      <aside
        className={[
          "app-sidebar",
          sidebarOpen ? "open"      : "",
          collapsed   ? "collapsed" : "",
        ].filter(Boolean).join(" ")}
      >
        {/* Brand */}
        <div className="sidebar-brand">
          <a href="/Inicio" className="sidebar-logo-link">
            <img
              src={process.env.PUBLIC_URL + "/logoInstitucion.png"}
              alt="logo"
              style={{ maxHeight: 44, width: "auto" }}
            />
          </a>
          <button
            className="sidebar-collapse-btn"
            onClick={toggleCollapse}
            title={collapsed ? "Expandir" : "Comprimir"}
          >
            {collapsed ? <IcChevR /> : <IcChevL />}
          </button>
        </div>

        {/* Nav */}
        <nav className="sidebar-nav">
          {NAV_SECTIONS.map((sec) => {
            // Los usuarios de tienda solo ven la opcion Tiendas
            const visibleItems = sec.items.filter((i) =>
              esDeTienda ? (i.perm === "pos" || i.perm === "posReportes") && hasPerm(i.perm) : hasPerm(i.perm)
            );
            if (visibleItems.length === 0) return null;

            return (
              <div key={sec.section} className="sidebar-section-group">
                <div className="sidebar-section">{sec.section}</div>

                {visibleItems.map((item) => {
                  const isActive = currentPath === item.href;
                  return (
                    <a
                      key={item.href}
                      href={item.href}
                      className={`sidebar-item${isActive ? " active" : ""}`}
                      title={collapsed ? item.label : ""}
                    >
                      {item.icon}
                      <span className="sidebar-label">{item.label}</span>
                    </a>
                  );
                })}
              </div>
            );
          })}
        </nav>

        {/* User footer */}
        <div className="sidebar-footer">
          <div
            className="sidebar-item"
            onClick={() => !collapsed && setUserMenuOpen(!userMenuOpen)}
            title={collapsed ? (user.nombre || user.email || "Usuario") : ""}
            style={{ justifyContent: collapsed ? "center" : "space-between" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 11 }}>
              <IcUserCircle />
              <span className="sidebar-label" style={{ fontSize: "0.78rem" }}>
                {user.nombre || user.email || "Usuario"}
              </span>
            </div>
            {!collapsed && (
              userMenuOpen ? <IcChevD /> : <IcChevU />
            )}
          </div>

          {userMenuOpen && !collapsed && (
            <div className="sidebar-submenu">
              <div
                className="sidebar-item sidebar-item-sm"
                onClick={() => { setModalPassword(true); setUserMenuOpen(false); }}
              >
                <IcLock />
                <span>Cambiar contraseña</span>
              </div>
              <a href="/Logout" className="sidebar-item sidebar-item-sm" style={{ color: "#f87171" }}>
                <IcSignOut />
                <span>Cerrar sesión</span>
              </a>
            </div>
          )}
        </div>
      </aside>

      {/* ── Password modal ───────────────────────────────────────────────── */}
      <Modal size="sm" isOpen={modalPassword} toggle={() => setModalPassword(false)}>
        <ModalHeader toggle={() => setModalPassword(false)}>
          Cambio de contraseña
        </ModalHeader>
        <ModalBody>
          <Password />
        </ModalBody>
      </Modal>
    </>
  );
};

export default Header;
